import styles from './style.module.scss';
import { WebPNextImage as Image, WebPNativeImage } from '../WebPImage';
import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { src } from '../../utils/common';

export const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 10000,
    width: '100vw',
    height: '100vh',
    padding: '82px 40px 82px 40px',
  },
  content: {
    position: 'relative',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    padding: '0 0',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    transform: 'translate(-50%, -50%)',
  },
};

const FullScreenContainer = ({ picUrl }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#__next');
  }, []);

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleClickFullscreenIcon = () => {
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <main>
      <section className={styles['full-screen-container']}>
        <WebPNativeImage
          className={styles['fullscreen-image']}
          src={src(picUrl)}
          alt="架构图"
        />
        <div
          onClick={handleClickFullscreenIcon}
          className={styles['fullscreen-icon']}
        >
          <Image
            layout={'fill'}
            draggable={false}
            alt="全屏"
            src={'/img/fullscreen-open.webp'}
          />
        </div>
      </section>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        style={customStyles}
        contentLabel="全屏"
      >
        <section className={styles['fullscreen-pic-container']}>
          <WebPNativeImage
            src={src(picUrl)}
            alt=""
            className={styles['fullscreen-image']}
          />
          <div
            onClick={handleClickFullscreenIcon}
            className={styles['fullscreen-icon-close']}
          >
            <Image
              layout={'fill'}
              draggable={false}
              alt="全屏"
              src={'/img/fullscreen-close.webp'}
            />
          </div>
        </section>
      </Modal>
    </main>
  );
};

export default FullScreenContainer;
